export default __webpack_public_path__ + "static/location-pin-31eb4349ae2546ba68b8cfa5c6915d8f.png";